import { render } from "./shezhenAndshemen.vue?vue&type=template&id=5e450b81&scoped=true"
import script from "./shezhenAndshemen.vue?vue&type=script&lang=js"
export * from "./shezhenAndshemen.vue?vue&type=script&lang=js"

import "./shezhenAndshemen.vue?vue&type=style&index=0&id=5e450b81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e450b81"]])

export default __exports__